// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2CYQS","resendInfoText":"OnGoingPaymentBox_resendInfoText__3iwIJ"};